import { reviewsApi } from "@/apis/apis";
import BaseTable from "./BaseTable";
import { useColumns } from "./Columns";
import ReviewModal from "@/Modals/ReviewModal/Modal";

export default function ReviewsPage() {
  const columns = useColumns();

  return (
    <BaseTable
      label="Transaction"
      apiURL={reviewsApi}
      columns={columns}
      enableAdd={true}
      ModalComponent={ReviewModal}
      enableActions={false}
      importData={null}
      enableExport={false}
      enableStatus={false}
      enableSortData={false}
    />
  );
}
